import * as React from 'react'
import './styles.css'
import '../Overview/styles.css'
import Carousel from '../Overview/components/Carousel'
import { ReactComponent as Dashboards } from '../../../assets/imgs/overview/dashboards_graphic.svg'
import { motion } from 'motion/react'
import { descriptionAnimation, subtitleAnimation } from '../../../constants/animation'

const HomeHeroVisuals = () => {
  return (
    <section className='home-hero-visuals-section'>
      <div className='box'>
        <div
          className='home-hero-visuals-grid'
          aria-label='Strategic workforce visuals'
        >
          <motion.div
            className='overview-tile-container dark-background box-relative-gradient'
            initial='hidden'
            whileInView='visible'
            viewport={{ once: true, amount: 0.2 }}
            variants={descriptionAnimation}
          >
            <div className='home-hero-visual-content home-hero-dashboard-wrapper'>
              <motion.div
                className='home-hero-dashboard-motion'
                animate={{ y: [0, -6, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
              >
                <Dashboards className='elements home-hero-dashboard-visual' />
              </motion.div>
            </div>
            <div className='description-wrapper'>
              <div className='description-title'>Dashboards and Key Metrics</div>
              <div className='description-subtitle'>
                Track performance, monitor hiring pipelines, and align talent
                strategies instantly.
              </div>
            </div>
          </motion.div>
          <motion.div
            className='overview-tile-container gradient-top-right box-relative-gradient'
            initial='hidden'
            whileInView='visible'
            viewport={{ once: true, amount: 0.2 }}
            variants={subtitleAnimation}
          >
            <div className='home-hero-visual-content'>
              <Carousel />
            </div>
            <div className='description-wrapper'>
              <div className='description-title'>
                Heat Mapping for Strategic Workforce Analysis
              </div>
              <div className='description-subtitle'>
                Pod&apos;s powerful heat mapping functionality enables
                organizations to visualize talent.
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default HomeHeroVisuals
